module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ialm4o/images/cover.jpg?1685327061123",
      "alt": "This image is the cover for the book Still"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Still\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("What happens when two men who have been together for seventeen years fall out of love? Sivan Cruz, a set director in San Francisco, and Walter Wainwright, a big shot Bay Area lawyer, find out the hard way. Walter loves Sivan with all his heart but rarely talks about it, and Sivan needs to hear the words. The language of the love they have shared for so long, that has enabled them to build a life together and raise two children, stops working. They become—still.")]), _c('p', [_vm._v("When Sivan asks for a divorce, Walter doesn’t know how to say no. They separate, but while Sivan sees the relationship as over, Walter sees only a temporary setback. He has never lost his passion for Sivan and decides he has to say something before he ends up loving his husband in silence for the rest of his life.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary Calmes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mary Calmes believes in romance, happily ever afters, and the faith it takes for her characters to get there. She bleeds coffee, thinks chocolate should be its own food group, and currently lives in Kentucky with a five-pound furry ninja that protects her from baby birds, spiders, and the neighbor’s dogs. To stay up to date on her ponderings and pandemonium (as well as the adventures of the ninja), follow her on Twitter @MaryCalmes, connect with her on Facebook, and subscribe to her Mary’s Mob newsletter.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0